import { useEffect, useReducer } from 'react'
import { rest } from 'utils/axiosInstance'
import { useLocation } from 'react-router'
import { AuthUser, AuthUserProperties, pathify } from 'shared'
import { errorHandler } from 'hooks/errorHandler'
import axios from 'axios'
import { createStrictContext } from 'utils/createContext'

interface AuthContext {
  user: AuthUser | null
}

const { Provider, useContextFn } =
  createStrictContext<AuthContext>('AuthContext')

const unauthenticatedRoutes: string[] = []

export const AuthProvider: React.FC = ({ children }) => {
  const [user, dispatch] = useReducer(
    (state: AuthUser | null, payload: AuthUserProperties) => {
      if (JSON.stringify(state?.properties) !== JSON.stringify(payload))
        return AuthUser.create(payload)
      return state
    },
    null
  )
  const { pathname } = useLocation()

  useEffect(() => {
    const { token: cancelToken, cancel } = axios.CancelToken.source()
    if (unauthenticatedRoutes.includes(pathname)) return
    rest
      .get<AuthUserProperties>(pathify('auth', 'user'), { cancelToken })
      .then(({ data }) => dispatch(data))
      .catch((err) => {
        if (axios.isCancel(err)) return
        if (err?.response?.status === 404)
          return window.location.replace(process.env.REACT_APP_LOGIN_URL!)
        if (err?.response?.data?.startsWith('Proxy error')) errorHandler(err)
        // using console.error here on purpose as to not blow up the app
        else console.error(err)
      })
    return () => {
      cancel()
    }
  }, [pathname])

  return <Provider value={{ user }}>{children}</Provider>
}

export const useAuthContext = useContextFn
